import Endpoint from '../api/endpoint.js'
import { OK, INTERNAL_SERVER_ERROR, CREATED, ServerLoading } from '../util.js'

const state = {
  users: [],
  apiStatus: null,
  errorMessages: null,
  start: 0,
  current: 0,
  newsList: [],
  groupList: null,
  groupNewsList: [],
}

const getters = {
  /**
   * グループリストを返す
   */
  groups: (state) => {
    return state.groupList
  },
  /**
   * 渡されたグループIDのグループ情報を返す
   */
  groupName: (state) => (index) => {
    return state.groupList.find(group => group.id === index)
  },
  /**
   * 渡されたグループIDの記事が未読の個数を返す
   * @param {*} group 
   */
  unreadNews: (state) => (index) => {
    if (state.newsList.length === 0) return []  //記事が一つもない場合はエラーになるのでからの配列を返す
    let lists = state.newsList.filter(news => news.group_id === index)
    return lists.filter(list => list.done === '0')  //サーバーから取得時にJSONで文字列として返されるので文字列比較で判定する
  },
  newsList: (state) => (group) => {
    return state.newsList.filter(news => news.group_id === group)
  }
}

const mutations = {
  setUsers(state, users) {
    state.users = users
  },
  setApiStatus(state, status) {
    state.apiStatus = status
  },
  setErrorMessages(state, messages) {
    state.errorMessages = messages
  },
  setItems(state, items) {
    state.newsList = items.news
    state.groupList = items.group
  },
  setNewsList(state, items) {
    state.groupNewsList = items
  }
}

const actions = {
  /**
   * すべてのユーザーを取得
   * @param {*} context 
   */
  async getUsers(context) {
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true, message: ServerLoading }, { root: true })

    const auth = context.rootGetters['auth/postUser']

    await Endpoint.users(auth).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('setUsers', response.data.users)
        context.commit('loading/clearLoading', null, { root: true })
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true })

    }).catch(function (error) {

      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true })
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if (error.response === undefined) {
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true })
      } else {
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true })
      }
    })
  },
  /**
   * ユーザー作成
   * @param {*} context 
   * @param {*} data
   * ダイアログで登録するためローディングは不要 
   */
  async createUser(context, data) {
    context.commit('setApiStatus', null)

    const auth = context.rootGetters['auth/postUser']
    data.token = auth.token
    data.user = auth.user

    //新規お知らせ登録API
    await Endpoint.singup(data).then(response => {
      if (response.status === CREATED) {
        //成功したらtrueを代入
        context.commit('setApiStatus', true)
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })

    }).catch(error => {
      context.commit('setApiStatus', false)
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if (error.response === undefined) {
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true })
      } else {
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true })
      }
    })
  },
  /**
   * ユーザー情報編集
   * @param {*} context 
   * @param {*} data
   * ダイアログで登録するためローディングは不要 
   */
  async editUser(context, data) {
    context.commit('setApiStatus', null)

    const auth = context.rootGetters['auth/postUser']
    data.token = auth.token
    data.user = auth.user

    //新規お知らせ登録API
    await Endpoint.editUser(data).then(response => {
      if (response.status === OK) {
        //成功したらtrueを代入
        context.commit('setApiStatus', true)
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })

    }).catch(error => {
      context.commit('setApiStatus', false)
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if (error.response === undefined) {
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true })
      } else {
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true })
      }
    })
  },
  /**
   * ユーザー情報削除
   * @param {*} context 
   * @param {*} data
   * ダイアログで登録するためローディングは不要 
   */
  async deleteUser(context, data) {
    context.commit('setApiStatus', null)

    const auth = context.rootGetters['auth/postUser']
    data.token = auth.token
    data.user = auth.user

    //ユーザー削除API
    await Endpoint.deleteUser(data).then(response => {
      if (response.status === OK) {
        //成功したらtrueを代入
        context.commit('setApiStatus', true)
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })

    }).catch(error => {
      context.commit('setApiStatus', false)
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if (error.response === undefined) {
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true })
      } else {
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true })
      }
    })
  },
  /**
   * ログイン時にユーザーの記事を取得
   * @param {*} context 
   */
  async getUserNewsList(context) {
    //tokenが保持されている場合は認証
    context.commit('setApiStatus', null)
    // context.commit('loading/setLoadingStatus', { loading: true, message: ServerLoading }, { root: true } )

    const auth = context.rootGetters['auth/postUser']

    await Endpoint.userNewsList(auth).then(response => {

      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('setItems', response.data)
        // context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      // context.commit('loading/clearLoading', null, { root: true } )

    }).catch(function (error) {

      context.commit('setApiStatus', false)
      // context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if (error.response === undefined) {
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true })
      } else {
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true })
      }
    })
  },
  /**
   * ユーザー記事のフィルタリング
   * @param {*} context 
   * @param {*} group 
   */
  async setNewsList(context, group) {
    context.commit('setNewsList', context.state.newsList.filter(news => news.group_id === group))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
